<h2 mat-dialog-title class="popup-header">Select Rock Model</h2>

<div class="popup-content">
  @if (rockModels.length > 0) {
    <div class="scroll">
      <table class="mat-elevation-z2 full-width">
        <thead>
          <tr>
            <th>Name</th>
            <th>Total Porosity</th>
            <th>Permeability</th>
            <th>Formation Factor</th>
          </tr>
        </thead>
        <tbody>
          @for (model of rockModels; track model) {
            <tr
              (click)="onRowClick(model)"
              [class.selected]="model.name === selectedRockModel?.name"
              >
              <td>{{ model.name }}</td>
              <td>{{ model.totalPorosity.toFixed(2) }}</td>
              <td>{{ model.permeability || 'N/A' }}</td>
              <td>{{ model.formationFactor || 'N/A' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="no-results">
      <mat-icon class="no-results-icon">info</mat-icon>
      <p>No rock models available for this upscaling image.</p>
    </div>
  }
</div>

<div class="popup-actions">
  <button class="btn btn-secondary" (click)="closeDialog()">Cancel</button>
  <button class="btn btn-primary" [disabled]="!selectedRockModel" (click)="selectRockModel()">
    Select
  </button>
</div>
